<template>
    <div class="main-container px-5 py-5 xl:px-16">
        <Toast />
        <AdminVoonixAdvertisersTable  />
    </div>
</template>
<script setup>
import { ref, computed } from "vue";
import { useToast } from 'primevue/usetoast';
import AdminVoonixAdvertisersTable from "./AdminVoonixAdvertisersTable.vue";
const toast = useToast();
import { useStore } from 'vuex';

const store = useStore();
</script>

<style scoped>
/* Your styles here */
.modal-content {
    width: 100vw;
}
</style>